<template>
  <div v-if="currentStep === 1" class="food-categories-component d-flex align-center mx-auto">
    <div class="search-field">
      <v-text-field
        v-model="localSearch"
        solo
        hide-details="auto"
        clearable
        placeholder="Поиск..."
        height="4.57em"
      >
        <template slot="append">
          <font-awesome-icon color="#FF9100" icon="search" />
        </template>
      </v-text-field>
    </div>
    <v-btn-toggle v-model="localCurrentCollection" dense group class="btn-toggle mx-auto">
      <v-slide-group show-arrows>
        <v-slide-item v-for="(collection, i) in collections" :key="i">
          <v-btn
            :value="collection.id"
            class="button font-weight-medium text-normalize"
            depressed
          >
            {{ collection.name }}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-btn-toggle>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'FoodCategories',
    computed: {
      ...mapState({
        currentCategory: (state) => state.fastOrder.currentCategory,
        currentCollection: (state) => state.fastOrder.currentCollectionId,
        menuItemsList: (state) => state.fastOrder.menuItemsList,
        collections: (state) => state.fastOrder.collectionsList,
        currentStep: (state) => state.fastOrder.currentStep,
        searchMenu: state => state.fastOrder.searchMenu,
      }),
      localSearch: {
        get () {
          return this.searchMenu
        },
        set (value) {
          this.$store.commit('fastOrder/setSearchMenu', value)
        },
      },
      localCurrentCollection: {
        get () {
          return this.currentCollection
        },
        set (value) {
          if (value !== undefined) {
            this.$store.commit('fastOrder/setMenuItemsLoading', true)
            this.$store
              .dispatch('collections/fetchSingleCollections', value)
              .then((res) => {
                if (res.status === 200) {
                  this.$store.commit(
                    'fastOrder/setMenuItemsList',
                    res.data.data.menuItems,
                  )
                }
                this.$store.commit('fastOrder/setMenuItemsLoading', false)
              })
          } else {
            this.$store.commit('fastOrder/setMenuItemsLoading', true)
            const id = this.currentCategory
            this.$store
              .dispatch('categories/fetchFilialMenuSingleCategories', { id })
              .then((res) => {
                if (res.status === 200) {
                  this.$store.commit(
                    'fastOrder/setMenuItemsList',
                    res.data.data.menuItems,
                  )
                }
                this.$store.commit('fastOrder/setMenuItemsLoading', false)
              })
          }
          this.$store.commit('fastOrder/setCurrentCollectionId', value)
        },
      },
    },
    beforeDestroy () {
      this.$store.commit('fastOrder/setSearchMenu', '')
    },
  }
</script>

<style lang="less" scoped>
.food-categories-component {
  margin-bottom: 2.5em;
  max-width: 100%;
  height: 4.57em;
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .search-field {
    width: 35%;

    .media-xl({
      width: 40%;
    });

    &::v-deep {
      .v-input {
        font-size: 1em;

        input {
          font-size: 1.4em;
        }
      }

      .v-input__slot {
        height: 4.57em;
        border-radius: 5px;
        box-shadow: none !important;
      }

      .v-input__slot {
        background-color: @color-secondary !important;
      }

      label {
        color: #c4cdd9 !important;
      }
    }
  }

  .btn-toggle {
    max-width: 65%;
    .media-xl({
      max-width: 60%;
    });
  }

  .button {
    border-radius: 10px;
    font-size: 1.14em;
    line-height: 21px;
    background-color: @color-secondary !important;
    height: 4.01em;
    padding: 0 23px;
    margin-right: 1.31em;

    &:before {
      content: none;
    }

    &.v-item--active {
      background-color: @color-primary !important;
      color: #ffffff;
    }
  }
}
</style>
